import DefaultElementNodeType from '../DefaultElementNodeType';
import {PHYSICAL_MATERIAL} from '../../metamodel/Concept';

export default class MaterialNodeType extends DefaultElementNodeType {
	static get typeName() {
		return PHYSICAL_MATERIAL;
	}
}
